var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartPocketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5533 7.74328L18.2086 7.25016C17.2774 7.1143 16.4754 6.52055 16.0582 5.66514L14.5634 2.59574C13.5155 0.444648 10.4886 0.444648 9.44077 2.59574L7.94594 5.66514C7.52878 6.52055 6.72674 7.11179 5.79558 7.25016L2.45085 7.74328C0.106805 8.08796 -0.829323 11.0064 0.864149 12.6795L3.28269 15.0671C3.95809 15.7313 4.26351 16.6923 4.10707 17.6308L3.53348 21.0046C3.1337 23.3695 5.58452 25.1734 7.68025 24.0589L10.6699 22.4638C11.5017 22.021 12.4975 22.021 13.3293 22.4638L16.3189 24.0589C18.4147 25.1734 20.863 23.3721 20.4657 21.0046L19.8921 17.6308C19.7332 16.6923 20.0411 15.7313 20.7165 15.0671L23.135 12.6795C24.8285 11.0039 23.8949 8.08544 21.5533 7.74328ZM7.64549 14.0582C6.76647 14.0582 6.0563 13.1625 6.0563 12.0606C6.0563 10.9586 6.76647 10.0655 7.64549 10.0655C8.5245 10.0655 9.23467 10.9611 9.23467 12.0606C9.23467 13.16 8.5245 14.0582 7.64549 14.0582ZM14.0966 14.0582C13.2176 14.0582 12.5074 13.1625 12.5074 12.0606C12.5074 10.9586 13.2176 10.0655 14.0966 10.0655C14.9756 10.0655 15.6858 10.9611 15.6858 12.0606C15.6858 13.16 14.9756 14.0582 14.0966 14.0582Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartPocketIcon);
export default __webpack_public_path__ + "static/media/smart-pocket-icon.20d1630a1335522b65e481c2b675a069.svg";
export { ForwardRef as ReactComponent };